"use strict";

exports.__esModule = true;
exports.createTriggerProcessorState = createTriggerProcessorState;
/**
 * Create an initial trigger processor state.
 */
function createTriggerProcessorState(triggers, delay) {
  if (delay === void 0) {
    delay = 30000;
  }
  return {
    lastActionAt: 0,
    delay: delay,
    triggers: triggers instanceof Map ? triggers : new Map(triggers),
    results: []
  };
}